import React from 'react';

const MarqueeTicker: React.FC = () => {
    const items = [
        '🦆 $DUCK TO THE MOON',
        '🚀 BONDING CURVE LIVE ON NAD.FUN',
        '⚡ POWERED BY MONAD',
        '💎 DIAMOND HANDS ONLY',
        '🏊 JOIN THE POND',
        '🔒 90% LIQUIDITY LOCKED',
        '🌊 QUACK QUACK QUACK',
        '🐤 EARLY DUCK GETS THE WORM',
    ];

    const repeatedItems = [...items, ...items];

    return (
        <div className="marquee-ticker">
            <div className="marquee-track">
                {repeatedItems.map((item, index) => (
                    <span key={index} className="marquee-item">
                        {item}
                        <span className="marquee-separator">•</span>
                    </span>
                ))}
            </div>
        </div>
    );
};

export default MarqueeTicker;
